import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLoginStatus, setUser } from '../redux/users/reducer';
import { Button, Container, Grid } from '@mui/material';
import '../styles/Login.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [troubleSigningIn, setTroubleSigningIn] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.users?.user);

  const isLoggedIn =
    useSelector((state) => state.users?.isLoggedIn) &&
    localStorage.getItem('token') !== null;

  const handleLogin = async (e) => {
    e.preventDefault();

    if (
      username === null ||
      username === undefined ||
      username.length === 0 ||
      password === null ||
      password === undefined ||
      password.length === 0
    ) {
      window.alert('Please enter your email address and password.');
      return;
    }

    try {
      const response = await axios.post('https://api.innofitness.ca/login', {
        username,
        password,
      });

      // Extract access token from the response headers
      const token = response.headers['access'];
      if (token) localStorage.setItem('token', token);
      dispatch(setLoginStatus(true));
      navigate('/profile');
    } catch (error) {
      window.alert(
        "Please check your credentials.\nIf you don't have an account with us, please sign up first."
      );
      setTroubleSigningIn(true);
      setUsername('');
      setPassword('');
    }
  };

  useEffect(() => {
    if (user && isLoggedIn) {
      navigate('/profile');
    }
  });

  return (
    <Container
      className="page-container"
      sx={{ maxWidth: '1200px', px: 'max(2%, 16px) !important' }}
    >
      <div className="page-title">
        <h1 style={{ textAlign: 'center' }}>Inno Fitness Centre</h1>
        <p>Please sign in to continue.</p>
      </div>
      <form onSubmit={handleLogin}>
        <Grid className="grid-container" sx={{ gap: '15px' }}>
          <div style={{ margin: '0 auto' }}>
            <span className="login-label">
              <label htmlFor="email">
                <b>Email:</b>
              </label>
            </span>
            <span>
              <input
                type="email"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </span>
          </div>
          <div style={{ margin: '0 auto' }}>
            <span className="login-label">
              <label htmlFor="password">
                <b>Password:</b>
              </label>
            </span>
            <span>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </span>
          </div>
        </Grid>
        <Grid
          direction="row"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '15px',
            pt: '20px',
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            sx={{ width: { xs: '100px', sm: '150px' } }}
          >
            Login
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => navigate('/register')}
            sx={{ width: { xs: '100px', sm: '150px' } }}
          >
            Sign Up
          </Button>
        </Grid>
      </form>
      {troubleSigningIn && (
        <p style={{ textAlign: 'center', color: 'red', marginTop: '24px' }}>
          Trouble signing in?
          <br />
          Please let{' '}
          <a
            href="https://teams.microsoft.com/l/chat/0/0?users=jiyoung.kim@innofoods.ca"
            title="jiyoung.kim@innofoods.ca"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ji Young
          </a>{' '}
          know!
        </p>
      )}
    </Container>
  );
}
